import { MMArrowButton, PageShell } from '@components'
import cn from '@integrations/classnames'
import type { ReactNode } from '@integrations/react'

interface Props {
  onBackClick: () => void
  children: ReactNode
}

function BackPageContainer({ onBackClick, children }: Props) {
  return (
    <>
      <MMArrowButton onClick={onBackClick} />
      <PageShell align='center' className={cn('back-page-wrapper')}>
        {children}
      </PageShell>
    </>
  )
}

export default BackPageContainer
